<template>
    <div class="o-content-header content-header">
        <svg-icon
            :name="`icons/${icon}`"
            original
            class="content-header__icon"
        />
        <div class="content-header__wrapper">
            <h2 class="content-header__title">
                {{ $t(title) }}
            </h2>
            <span
                class="content-header__subtitle"
                v-html="$t(subTitle)"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'OContentHeader',
    props: {
        /**
         * Icon for header
         */
        icon: {
            type: String,
            default: ''
        },
        /**
         * Main title
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * Subtitle
         */
        subTitle: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-content-header";
</style>
